export type PwaSessionMe = {
  user: {
    id: string;
    email: string;
    name: string | null;
    role: { id: string; key: string; name: string } | null;
  };
  organization: { id: string; name: string; slug: string; logoUrl?: string | null };
  permissions: string[];
};

export function permissionSatisfies(granted: Set<string> | string[], required: string): boolean {
  const g = granted instanceof Set ? granted : new Set(granted);
  if (g.has(required)) return true;
  const parts = required.split('.');
  if (parts.length !== 3) return false;
  const [surface, module, action] = parts;
  if (action === 'read') {
    if (g.has(`${surface}.${module}.write`)) return true;
    if (g.has(`${surface}.${module}.manage`)) return true;
  }
  if (action === 'write' && g.has(`${surface}.${module}.manage`)) return true;
  return false;
}

export function hasPermission(granted: Set<string> | string[], required: string | string[]): boolean {
  const list = Array.isArray(required) ? required : [required];
  return list.some((p) => permissionSatisfies(granted, p));
}

export const PWA_TAB_PERMISSIONS: Record<string, string> = {
  '/': 'pwa.home.read',
  '/notifications': 'pwa.notifications.read',
  '/conversations': 'pwa.conversations.read',
  '/calendar': 'pwa.calendar.read',
  '/reservas': 'pwa.calendar.read',
};
